import script from "./ExchangeRate.vue?vue&type=script&lang=ts&setup=true"
export * from "./ExchangeRate.vue?vue&type=script&lang=ts&setup=true"

import "./ExchangeRate.vue?vue&type=style&index=0&id=3c20d11e&scoped=true&lang=css"

import exportComponent from "/home/forge/tenant.mybcr.dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3c20d11e"]])

export default __exports__